import React, { FC } from 'react'
import Dots from '../../../atoms/Dots/Dots'
import images from '../../../../app/utlis/image'
import { motion } from 'framer-motion'

interface CommitmentCareerProps {
    careerData: any
}

const CommitmentCareer: FC<CommitmentCareerProps> = ({ careerData }) => {
    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { 
                duration: 0.5
            }
        },
        hover: { 
            scale: 1.03, 
            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
            transition: { duration: 0.3 }
        }
    }

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    }

    const fadeInLeft = {
        hidden: { opacity: 0, x: -30 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    }

    const popIn = {
        hidden: { opacity: 0, scale: 0.8 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: { type: "spring", stiffness: 300, damping: 15 }
        },
        hover: {
            scale: 1.1,
            rotate: [0, -5, 5, 0],
            transition: { duration: 0.4 }
        }
    }

    return (
        <div>
            <motion.div 
                className={`flex justify-center items-center relative pt-8 sm:pt-10 md:pt-12`}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={fadeInUp}
            >
                <div className='flex flex-col justify-center items-center gap-2 sm:gap-3'>
                    <motion.div 
                        className='text-yellow text-base sm:text-lg tracking-widest uppercase'
                        variants={fadeInUp}
                    >
                        Why join us?
                    </motion.div>
                    <motion.div 
                        className='font-medium text-2xl sm:text-3xl md:text-4xl font-sans text-center px-4 sm:px-8 md:px-16 lg:px-24 leading-snug'
                        variants={fadeInUp}
                    >
                        The passion & commitment to that mission
                        lives through everything we do.
                    </motion.div>
                    <motion.div variants={fadeInUp}>
                        <Dots width='w-5 sm:w-7' height='h-5 sm:h-7' className='mt-1 sm:mt-2' />
                    </motion.div>
                </div>
            </motion.div>
            <motion.div 
                className='grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 p-4 sm:p-8 md:p-12 lg:p-20 py-8 sm:py-12 md:py-16 px-4 sm:px-8 md:px-16 lg:px-36'
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.1 }}
            >
                {careerData.ReliabilityCareerData.map((reliable: any, index: number) => {
                    return (
                        <motion.div 
                            key={index} 
                            className='bg-darkGreyQuaternary relative'
                            variants={index % 2 === 0 ? fadeInUp : fadeInLeft}
                            whileHover="hover"
                            animate="visible"
                        >
                            <motion.div 
                                className='w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full bg-darkGreyPrimary absolute z-10 right-[7%] top-[20%]'
                                variants={popIn}
                            >
                                <div className='flex items-center justify-center w-full h-full'>
                                    <img src={reliable.image} className='w-[50%]' />
                                </div>
                            </motion.div>
                            <motion.div 
                                className='bg-yellow pr-12 sm:pr-16 md:pr-20'
                                variants={{
                                    hover: { x: [0, 5, -5, 0], transition: { duration: 0.5 } }
                                }}
                            >
                                <div className={`flex flex-col items-start justify-start p-4 sm:p-6 md:p-8 pt-4 sm:pt-5 md:pt-6 relative bg-darkGreyTernary`}>
                                    <div className={`text-lg sm:text-xl text-start font-semibold pb-1 sm:pb-2 text-white`}>{reliable.title}</div>
                                    <div className={`text-lightGrey text-start text-sm sm:text-base md:text-m w-full border-${reliable.color} pr-2 sm:pr-4`}>{reliable.subtitle}</div>
                                </div>
                            </motion.div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </div>
    )
}

export default CommitmentCareer
